(() => {
  if (customElements.get('singles-catalog-navigation')) return;

  class SinglesCatalogNavigation extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      const viewport = this.querySelector('[data-featured-links-viewport]');
      if (!viewport) return;
      const previous = this.querySelector('[data-featured-links-previous]');
      const next = this.querySelector('[data-featured-links-next]');
      let positionPanel = () => {};

      const updateArrows = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        if (previous) previous.disabled = viewport.scrollLeft <= 2;
        if (next) next.disabled = viewport.scrollLeft >= maxScroll - 2;
      };
      const move = (direction) => {
        const firstCard = viewport.querySelector('.singles-api-search__featured-item');
        const list = viewport.querySelector('.singles-api-search__featured-list');
        const gap = list ? Number.parseFloat(window.getComputedStyle(list).gap) || 0 : 0;
        const distance = (firstCard?.getBoundingClientRect().width || viewport.clientWidth * 0.75) + gap;
        viewport.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous?.addEventListener('click', () => move(-1), { signal });
      next?.addEventListener('click', () => move(1), { signal });
      viewport.addEventListener('scroll', updateArrows, { passive: true, signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => { updateArrows(); positionPanel(); });
        this.resizeObserver.observe(viewport);
      }
      updateArrows();

      const toggle = this.querySelector('[data-eras-toggle]');
      const panel = this.querySelector('[data-eras-panel]');
      if (!toggle || !panel) return;
      positionPanel = () => {
        if (panel.hidden) return;
        const container = this.getBoundingClientRect();
        const button = toggle.getBoundingClientRect();
        const visible = window.visualViewport;
        const inset = 16;
        const viewportLeft = visible?.offsetLeft || 0;
        const viewportTop = visible?.offsetTop || 0;
        const viewportRight = viewportLeft + (visible?.width || window.innerWidth);
        const viewportBottom = viewportTop + (visible?.height || window.innerHeight);
        panel.style.setProperty('--eras-panel-max-width', `${Math.max(0, viewportRight - viewportLeft - inset * 2)}px`);
        const minLeft = viewportLeft + inset - container.left;
        const maxLeft = viewportRight - inset - panel.offsetWidth - container.left;
        const left = Math.max(minLeft, Math.min(button.left - container.left, maxLeft));
        panel.style.setProperty('--eras-panel-left', `${left}px`);

        const headerHeight = panel.querySelector('.singles-api-search__eras-header').offsetHeight;
        const list = panel.querySelector('.singles-api-search__eras-list');
        const styles = window.getComputedStyle(panel);
        const borderHeight = (parseFloat(styles.borderTopWidth) || 0) + (parseFloat(styles.borderBottomWidth) || 0);
        const height = Math.min(headerHeight + list.scrollHeight + borderHeight, Math.max(0, viewportBottom - viewportTop - inset * 2));
        const below = container.bottom + 10;
        const above = container.top - 10 - height;
        const preferred = below + height <= viewportBottom - inset ? below : above >= viewportTop + inset ? above : below;
        const top = Math.max(viewportTop + inset, Math.min(preferred, viewportBottom - inset - height));
        panel.style.setProperty('--eras-panel-top', `${top - container.top}px`);
        panel.style.setProperty('--eras-list-max-height', `${Math.max(0, height - headerHeight - borderHeight)}px`);
      };
      const setOpen = (open, restoreFocus = false) => {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) positionPanel();
        if (restoreFocus) toggle.focus({ preventScroll: true });
      };
      toggle.addEventListener('click', () => setOpen(panel.hidden), { signal });
      panel.querySelector('[data-eras-close]')?.addEventListener('click', () => setOpen(false, true), { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          setOpen(false, true);
        }
      }, { signal });
      document.addEventListener('pointerdown', (event) => {
        if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
      }, { signal });
      window.addEventListener('resize', positionPanel, { signal });
      window.addEventListener('scroll', positionPanel, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', positionPanel, { signal });
      window.visualViewport?.addEventListener('scroll', positionPanel, { passive: true, signal });
      viewport.addEventListener('scroll', positionPanel, { passive: true, signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('singles-catalog-navigation', SinglesCatalogNavigation);
})();
